import React, { useState } from 'react';
import { Grid, Paper } from '@material-ui/core';

import Chart from 'react-apexcharts';
import { levels } from '../../../utils/constants';
import { stateChart } from '../../../utils/stateChart';
import styled from 'styled-components';

const initialState = stateChart([
  levels.JUNIOR,
  levels.SENIOR,
  levels.NO_ASIGNADO,
  'EN BLANCO',
]);

const ReportByLevel = ({ data }) => {
  const [state] = useState(initialState);

  const quantityResearchersByLevel = (level) => {
    const res = data.filter((researcher) => researcher.level === level);
    return res.length;
  };

  return (
    <Grid item xs={12} sm={12} md={7} lg={4} >
      <Paper className='paper' style={{ marginTop: '2em' }}>
        <TitlePaper>Investigadores por nivel</TitlePaper>
        <Chart
          options={state.options}
          series={[
            quantityResearchersByLevel(levels.JUNIOR),
            quantityResearchersByLevel(levels.SENIOR),
            quantityResearchersByLevel(levels.NO_ASIGNADO),
            quantityResearchersByLevel(null),
          ]}
          type='pie'
          height={380}
          className='chart'
        />
      </Paper>
    </Grid>
  );
};

const TitlePaper = styled.h3`
  margin: 0;
`;

export default ReportByLevel;
